module.exports = __webpack_public_path__ + "static/img/img-honor1.3ee9840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor1.png
// module id = CMQY
// module chunks = 1